/** Every UI string in this app carries both languages. There is no other shape. */
export type Phrase = {
  /** Panamanian Spanish, tu form, warm and short, third grade reading level for staff. */
  es: string;
  /** English. Tim reads English, so nothing ships in Spanish he cannot read beside it. */
  en: string;
};

export type Lang = 'es' | 'en';

export const LANGS: readonly Lang[] = ['es', 'en'] as const;

/** A dictionary section: flat, dotted keys, one Phrase each. */
export type Section = Record<string, Phrase>;

/** Values interpolated into a phrase, as {name} placeholders. */
export type Vars = Record<string, string | number>;

export function otherLang(lang: Lang): Lang {
  return lang === 'es' ? 'en' : 'es';
}
